module.exports = __webpack_public_path__ + "img/Mike.5d1a30bb.jpg";